(() => {
  class AnchorLinks extends HTMLElement {
    /**
     * Initializes the AnchorLinks component.
     */
    constructor() {
      super();

      this.SCROLL_GAP = 16;
    }

    /**
     * Lifecycle method called when the element is added to the DOM.
     */
    connectedCallback() {
      this.addListeners();
    }

    /**
     * Adds click and keydown event listeners to anchor links for smooth scrolling.
     */
    addListeners() {
      this.anchorLinks.forEach(link => {
        link.addEventListener("click", event => this.smoothScrollTo(event));
        link.addEventListener("keydown", event =>
          event.code.toUpperCase() === "ENTER" && this.smoothScrollTo(event)
        );
      });
    }

    /**
     * Smoothly scrolls to the target element, accounting for header and gap.
     * @param {Event} event - The click or keydown event.
     */
    smoothScrollTo(event) {
      event.preventDefault();

      const target = event.currentTarget.getAttribute("href");
      const targetElement = document.querySelector(target);

      if (!targetElement) return;

      const headerHeight = this.headerHeight;
      const targetTop = targetElement.getBoundingClientRect().top + window.scrollY;
      const elementPosition = targetTop - headerHeight - this.SCROLL_GAP;

      window.scrollTo({ top: elementPosition, behavior: 'smooth'});
    }

    /**
     * Returns all anchor link elements within the component.
     * @returns {NodeListOf<Element>} - A list of anchor link elements.
     */
    get anchorLinks() {
      return this.querySelectorAll("[data-anchor-link]");
    }

    /**
     * Returns the height of the header element, if present.
     * @returns {number} - The height of the header element or 0 if not found.
     */
    get headerHeight() {
      return document.querySelector("[data-header]")?.offsetHeight || 0;
    }
  }

  if (!customElements.get("anchor-links")) {
    customElements.define("anchor-links", AnchorLinks);
  }
})();